import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	commandPaletteGoToBacklog: {
		id: 'spa-apps-sidebar-common.command-palette.command-palette-go-to-backlog',
		defaultMessage: 'Go to backlog',
		description: 'Command in the command palette that navigates the user to the backlog',
	},
	commandPaletteGoToBoard: {
		id: 'spa-apps-sidebar-common.command-palette.command-palette-go-to-board',
		defaultMessage: 'Go to board',
		description: 'Command in the command palette that navigates the user to the board',
	},
	commandPaletteGoToReports: {
		id: 'spa-apps-sidebar-common.command-palette.command-palette-go-to-reports',
		defaultMessage: 'Go to reports',
		description: 'Command in the command palette that navigates the user to the reports',
	},
	commandPaletteGoToTimeline: {
		id: 'spa-apps-sidebar-common.command-palette.command-palette-go-to-timeline',
		defaultMessage: 'Go to timeline',
		description: 'Command in the command palette that navigates the user to the timeline',
	},
});
